<svelte:options accessors/>
<script>
    import NauiTable from "../../naui/components/NauiTable.svelte";
    export let data;

    function marginPercent(num) {
        return Math.floor(num * 100) + '%';
    }
</script>

<div class="py-15">
    <div class="grid-3-1">
        <table class="naui-table w-100">
            <tbody>
                <tr>
                    <td>
                        <div>Margen</div>
                    </td>
                    <td>
                        <div><sub class="mr-15">Empaque</sub> {marginPercent(data.margin.packaging)}</div>
                    </td>
                    <td>
                        <div><sub class="mr-15">Transporte</sub> {marginPercent(data.margin.transport)}</div>
                    </td>
                    <td>
                        <div><sub class="mr-15">Servicio</sub> {marginPercent(data.margin.avg)}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="grid-2 gap-15 mt-1">
        <NauiTable columns={data.packaging.columns} data={data.packaging.data}/>
        <NauiTable columns={data.transport.columns} data={data.transport.data}/>
    </div>
</div>
